module.exports = __webpack_public_path__ + "media/assets/images/right-arrow-4c63c2635d6ba1fc13f51e730d8b65af.svg";